"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
const core_1 = require("@material-ui/core");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const UploadPictureIcon_1 = __importDefault(require("@opsbase/web-icons/icons/UploadPictureIcon"));
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const Spinner_1 = __importDefault(require("../Spinner"));
const makeMyClasses = () => ({
    root: {
        position: 'relative',
    },
    bigavatar: {
        opacity: 1,
        width: '100%',
        height: '100%',
        '&:hover': {
            opacity: 0.2,
            transition: '0.5s ease',
        },
    },
    overlay: {
        borderRadius: '50%',
        backgroundColor: '#59656F',
        cursor: 'pointer',
        transition: '0.5s ease',
        display: 'inline-block',
        opacity: 0,
        position: 'absolute',
        transform: 'translate(-50%,-50%)',
        textAlign: 'center',
        top: '50%',
        left: '50%',
        width: '100%',
        height: '100%',
        '&:hover': {
            opacity: 0.8,
        },
    },
    text: {
        cursor: 'pointer',
        color: lib_palette_1.default.White.main,
        marginTop: 12,
        marginBottom: 12,
        letterSpacing: '0.01em',
        fontSize: 12,
        fontWeight: 800,
        paddingTop: 5,
    },
    fileInput: {
        display: 'none',
    },
    marginTop25: {
        marginTop: '25%',
    },
    marginTop30: {
        marginTop: '30%',
    },
    marginTop35: {
        marginTop: '32%',
    },
});
function Avatar(props) {
    const { user, size = 198, allowEdit = false, uploading = false, onImageChange, onImageRemove, } = props;
    const formId = 'inputProfileImage';
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const uploadProfileImage = (0, react_1.useCallback)(event => {
        if (!event.target.files.length)
            return;
        const file = event.target.files[0];
        onImageChange(file);
    }, [onImageChange]);
    const handleClickDeletePhoto = (0, react_1.useCallback)(() => {
        onImageRemove();
    }, [onImageRemove]);
    return (react_1.default.createElement(core_1.Grid, { className: myCss.root, container: true, alignItems: "center", justify: "space-evenly", style: { width: size + 'px', height: size + 'px' } },
        react_1.default.createElement(Spinner_1.default, { busy: uploading },
            react_1.default.createElement(core_1.Avatar, { className: myCss.bigavatar, src: user === null || user === void 0 ? void 0 : user.profileImageUrl }),
            allowEdit && (react_1.default.createElement(core_1.Grid, { container: true, direction: "column", alignItems: "center", justify: "space-around" },
                react_1.default.createElement(core_1.Grid, { className: (0, classnames_1.default)({
                        [myCss.marginTop25]: user === null || user === void 0 ? void 0 : user.hasProfileImage,
                    }, {
                        [myCss.marginTop35]: !(user === null || user === void 0 ? void 0 : user.hasProfileImage),
                    }) },
                    react_1.default.createElement("label", { htmlFor: formId },
                        react_1.default.createElement("input", { type: "file", accept: "image/*", onChange: event => uploadProfileImage(event), id: formId, className: myCss.fileInput }),
                        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "center", alignItems: "center" },
                            react_1.default.createElement(UploadPictureIcon_1.default, { htmlColor: "white", size: 20, marginRight: 4 }),
                            react_1.default.createElement(core_1.Typography, { className: myCss.text }, lib_i18n_1.default.t('upload').toUpperCase())))),
                (user === null || user === void 0 ? void 0 : user.hasProfileImage) && (react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "center", alignItems: "center" },
                    react_1.default.createElement(DeleteIcon_1.default, { htmlColor: "white", size: 20, marginRight: 4 }),
                    react_1.default.createElement(core_1.Typography, { className: myCss.text, onClick: handleClickDeletePhoto }, lib_i18n_1.default.t('delete').toUpperCase()))))))));
}
exports.Avatar = Avatar;
exports.default = Avatar;
